import { hotRanking } from "@/mocks/stories";
import { formatNumber } from "@/utils/format";
import { catNameMap } from "./catStyle";

export default function RankingSection() {
  const top = hotRanking.slice(0, 8);
  const max = top[0]?.views ?? 1;

  return (
    <section id="ranking" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-4">
          <div className="flex flex-col">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-800">
              <i className="ri-trophy-fill text-primary-500" /> 周榜
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
              本周吃瓜热榜
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">
              宿舍、课堂、群聊轮番上榜，围观人数最多的就是它。看看你是不是也笑过这几条。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["社死", "宿舍", "食堂", "广播站"].map((k) => (
                <span key={k} className="rounded-full bg-background-200/80 px-3 py-1 text-xs font-medium text-foreground-600">
                  #{k}
                </span>
              ))}
            </div>
            <div className="mt-5 hidden rounded-2xl border border-background-200 bg-background-50 p-4 text-center lg:block">
              <span className="text-4xl">🏆</span>
              <p className="mt-2 font-heading text-sm text-foreground-700">下周能冲上第一的，会是你宿舍的故事吗</p>
            </div>
          </div>

          <ol className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:col-span-3">
            {top.map((s, i) => {
              const rank = i + 1;
              const pct = Math.max(8, Math.round((s.views / max) * 100));
              return (
                <li key={s.id} className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
                  <div className="flex items-start gap-4">
                    <span
                      className={`font-heading text-2xl ${
                        rank <= 3 ? "text-primary-500" : "text-background-400"
                      }`}
                    >
                      {rank}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-full bg-background-200/70 px-2 py-0.5 text-[11px] font-bold text-foreground-600">
                          {catNameMap[s.category]}
                        </span>
                        <span className="text-xs text-foreground-400">{s.time}</span>
                      </div>
                      <h3 className="mt-1.5 line-clamp-2 font-heading text-base leading-snug text-foreground-900">
                        {s.title}
                      </h3>
                      <div className="mt-3 flex items-center gap-3">
                        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                          <div
                            className={`h-full rounded-full ${
                              rank <= 3 ? "bg-primary-500" : "bg-accent-400"
                            }`}
                            style={{ width: `${pct}%` }}
                          />
                        </div>
                        <span className="whitespace-nowrap text-xs text-foreground-500">
                          <i className="ri-eye-fill mr-1 text-primary-500" />
                          {formatNumber(s.views)} 围观
                        </span>
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}